// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AccountChangeController from "./account_change_controller"
application.register("account-change", AccountChangeController)

import AccountToggleController from "./account_toggle_controller"
application.register("account-toggle", AccountToggleController)

import AddressAutocompleteController from "./address_autocomplete_controller"
application.register("address-autocomplete", AddressAutocompleteController)

import Admin__MapController from "./admin/map_controller"
application.register("admin--map", Admin__MapController)

import CopyToClipboardController from "./copy_to_clipboard_controller"
application.register("copy-to-clipboard", CopyToClipboardController)

import CurrencyMaskController from "./currency_mask_controller"
application.register("currency-mask", CurrencyMaskController)

import DeliveryLocationsController from "./delivery_locations_controller"
application.register("delivery-locations", DeliveryLocationsController)

import DeliveryRequestMapController from "./delivery_request_map_controller"
application.register("delivery-request-map", DeliveryRequestMapController)

import DriverFilterController from "./driver_filter_controller"
application.register("driver-filter", DriverFilterController)

import DriverMapController from "./driver_map_controller"
application.register("driver-map", DriverMapController)

import DriverRegistrationController from "./driver_registration_controller"
application.register("driver-registration", DriverRegistrationController)

import DriverSelectController from "./driver_select_controller"
application.register("driver-select", DriverSelectController)

import FlatpickrController from "./flatpickr_controller"
application.register("flatpickr", FlatpickrController)

import FormRowController from "./form_row_controller"
application.register("form-row", FormRowController)

import LeasingChecklistController from "./leasing_checklist_controller"
application.register("leasing-checklist", LeasingChecklistController)

import LocationController from "./location_controller"
application.register("location", LocationController)

import LocationSelectController from "./location_select_controller"
application.register("location-select", LocationSelectController)

import LocationToggleController from "./location_toggle_controller"
application.register("location-toggle", LocationToggleController)

import ModalSharedController from "./modal_shared_controller"
application.register("modal-shared", ModalSharedController)

import MultiselectDropdownController from "./multiselect_dropdown_controller"
application.register("multiselect-dropdown", MultiselectDropdownController)

import OnschedController from "./onsched_controller"
application.register("onsched", OnschedController)

import PaymentController from "./payment_controller"
application.register("payment", PaymentController)

import PhoneMaskController from "./phone_mask_controller"
application.register("phone-mask", PhoneMaskController)

import PickupDatePickerController from "./pickup_date_picker_controller"
application.register("pickup-date-picker", PickupDatePickerController)

import RegionsRequiredController from "./regions_required_controller"
application.register("regions-required", RegionsRequiredController)

import SocialSecurityNumberMaskController from "./social_security_number_mask_controller"
application.register("social-security-number-mask", SocialSecurityNumberMaskController)

import TextareaAutosizeController from "./textarea_autosize_controller"
application.register("textarea-autosize", TextareaAutosizeController)

import TimeAgoController from "./time_ago_controller"
application.register("time-ago", TimeAgoController)

import TimeZoneController from "./time_zone_controller"
application.register("time-zone", TimeZoneController)

import TippyController from "./tippy_controller"
application.register("tippy", TippyController)

import ToastFlashController from "./toast_flash_controller"
application.register("toast-flash", ToastFlashController)

import UtcToLocalController from "./utc_to_local_controller"
application.register("utc-to-local", UtcToLocalController)

import VehicleController from "./vehicle_controller"
application.register("vehicle", VehicleController)
